export default {
  id: 'alberath',
  name: 'Alberath',
  theme: 'medieval',
  versionPrefix: '0',
  description: 'Medieval tactical warfare',
  pageTitle: 'Alberath - The Lost Aeons - Classic Strategy Game with a Twist',
  colors: {
    primary: '#d4af37',    // Gold
    secondary: '#8b4513',  // Saddle brown
    background: '#1a1410', // Dark brown
    text: '#f5e6d3',       // Parchment
  },
  fonts: {
    heading: '"MedievalSharp", serif',
    body: '"Crimson Text", serif',
  },
  logo: '/images/brands/alberath-logo.png',
  map: {
    tileSize: 42,           // Desktop (1024-1535px)
    tileSizeTablet: 36,     // Tablet (768-1023px)
    tileSizeMobile: 32,     // Mobile (480-767px)
    tileSizePortrait: 28,   // Portrait (< 480px)
    tileSizeWide: 48,       // Wide (≥ 1536px)
  },
  loading: {
    barColor: '#d4a94f',      // Gold (from theme)
    barGlow: '#d4a94f80',     // Gold with transparency
    backgroundColor: '#0d1a1a', // Dark teal background
    textColor: '#f5e6d3',     // Parchment text
  },
};
